let appearing=[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:'plot'}],updating=[{slot:'plot',startEnd:{start:0,end:.5}}],disappearing=[{slot:'intial'}];export default{"*.legend.legend":()=>({"legendGroup.appearing":appearing,"legendGroup.updating":updating,"legendGroup.disappearing":disappearing,"scroller.appearing":appearing,"scroller.updating":updating,"scroller.disappearing":disappearing})};


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-charts/src/_internal/components/legend/discrete/index.animation.js
// module id = null
// module chunks = 